import { transition, trigger, useAnimation } from '@angular/animations';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { LenderUser } from 'app/models/dto/lender-user.model';
import { Assignment } from 'app/services/claim-lead/assignment.model';
import { ClaimRestrictions } from 'app/services/claim-lead/claim-lead.service';
import { slideInUp, slideOutUp } from 'ng-animate';

@Component({
  selector: 'app-claim-lead-bar',
  templateUrl: './claim-lead-bar.component.html',
  styleUrls: ['./claim-lead-bar.component.scss'],
  animations: [
    trigger('animateIn', [
      transition(':enter',
        useAnimation(slideInUp, { params: { timing: 0.3 }})
      )
    ]),
    trigger('animateOut', [
      transition(':leave',
        useAnimation(slideOutUp, { params: { timing: 0.2 }})
      )
    ])
  ]
})
export class ClaimLeadBarComponent implements OnInit, OnChanges {

  @Input() nextAssignmentExists: boolean;
  @Input() claimRestrictions: ClaimRestrictions;
  @Input() flagHighPriority: boolean;
  @Input() loading: boolean;
  @Input() conflict: boolean;
  @Input() claimedLead: Assignment;
  @Input() user: LenderUser;

  @Output() refresh = new EventEmitter();
  @Output() getNext = new EventEmitter();
  @Output() ackNotAvailable = new EventEmitter();
  @Output() callNow = new EventEmitter();

  showCallNow: boolean = false;
  countDownTime: number = 15;
  timer: any;

  constructor(private router: Router) { }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.claimedLead && this.claimedLead?.id) {
      this.router.navigate(['/borrower/', this.claimedLead?.id]);
      if (!this.preventAutoDial()) {
        this.showCallNow = true;
        this.countDownTime = 15;
        this.countDown(this.countDownTime);
      }
    }
  }

  preventAutoDial() {
    return this.user?.permissions?.includes('preventAutoDial');
  }

  countDown(seconds: number) {
    if (this.showCallNow && seconds > 0) {
      this.countDownTime = seconds;
      this.timer = setTimeout(() => {
        this.countDown(this.countDownTime - 1);
      }, 1000);
    } else {
      this.handleCallNow();
    }
  }

  handleCallNow() {
    this.callNow.emit(this.claimedLead);
    clearTimeout(this.timer);
    this.showCallNow = false;
  }

  callInProgress() {
    return JSON.parse(localStorage.getItem('currentCall') || '{}')?.callId && !this.preventAutoDial() ? true : false;
  };

  ipAddressRestrict() {
    return (
      !this.claimRestrictions.isIpAddressWhitelisted
      && !this.user?.permissions?.includes('claimRestriction.ipAddress.ignore')
      && this.user?.permissions?.includes('claimRestriction.ipAddress.restrict')
    );
  };

  unattemptedRestrict() {
    return (
      !this.ipAddressRestrict()
      && this.claimRestrictions.unattemptedLeads.length > 0
      && this.user
      && !this.user?.permissions?.includes('claimRestriction.unattempted.ignore')
      && this.user?.permissions?.includes('claimRestriction.unattempted.restrict')
    );
  };

  unattemptedWarn() {
    return (
      this.claimRestrictions.unattemptedLeads.length > 0
      && this.user
      && this.user?.permissions?.includes('claimRestriction.unattempted.warn')
      && !this.ipAddressRestrict()
      && !this.unattemptedRestrict()
    );
  };

  claimDisabled() {
    return (
      this.callInProgress()
      || this.ipAddressRestrict()
      || this.unattemptedRestrict()
    );
  };
}
